<template>
  <!-- Main simile a "login-page" -->
  <main id="send-email-page" class="page-container">
    <!-- Messaggi di errore/successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Contenitore del form -->
    <div id="send-email-form">
      <!-- Form con classe simile a "login-form" -->
      <form class="send-email-form" @submit.prevent="requestPasswordReset">
        <h1>Recupera Password</h1>
        <div class="email-field">
          <input
            id="send-email"
            type="email"
            placeholder="Indirizzo email"
            v-model="email"
            required
          />
        </div>
        <button id="send-email-button" type="submit" :disabled="!email">
          INVIA EMAIL DI RECUPERO
        </button>
      </form>
    </div>
  </main>
</template>

<script>
export default {
  name: "SendEmailPage",
  data() {
    return {
      email: "",
      errorMessage: "",
      successMessage: "",
    };
  },
  methods: {
    async requestPasswordReset() {
      try {
        const response = await this.$axios.post("/auth/verify-email", {
          email: this.email,
        });
        // Se esito positivo:
        if (response.status === 200) {
          this.successMessage =
            response.data?.message ||
            "Controlla la tua email per il link di recupero";
          this.$toast.success(this.successMessage);
          // Mostra il messaggio di successo per 2 secondi, poi ricarica
          setTimeout(() => {
            this.$router.go(0);
          }, 2000);

          return;
        }
        // alert(
        //   response.data?.message ||
        //     "Controlla la tua email per il link di recupero!"
        // );
        // Reindirizza se vuoi
        // this.$router.push("/auth/reset-password");
      } catch (error) {
        console.error("Errore recupero password:", error);
        this.errorMessage =
          error.response?.data?.details ||
          "Errore durante la richiesta di recupero password.";
        this.$toast.error(this.errorMessage);
      }
    },
  },
};
</script>

<style src="@/css/SetNewPassword.css"></style>
